import { motion } from 'framer-motion'

const Dot = ({ delay, stop = false }: { delay: number; stop?: boolean }) => {
  return (
    <motion.div
      className="h-1 w-1 rounded-full bg-gray-400"
      animate={!stop ? { y: [0, -10, 0] } : { y: [0, 0, 0] }}
      transition={{
        duration: 0.75,
        repeat: Infinity,
        repeatDelay: 0.3,
        delay,
      }}
    />
  )
}

export function ChatInputIconAnimated({ stop = true }) {
  return (
    <div className="flex space-x-1">
      {stop ? (
        <>
          <Dot delay={0} stop />
          <Dot delay={0.4} stop />
          <Dot delay={0.6} stop />
        </>
      ) : (
        <>
          <Dot delay={0} />
          <Dot delay={0.4} />
          <Dot delay={0.6} />
        </>
      )}
    </div>
  )
}
